import styled from 'styled-components';

import {colors} from 'theme';

export const MapWrapper = styled.div`
    width: 100%;
    height: 500px;
    grid-column: 1 / -1;
`;

export const Popup = styled.div`
    background: ${colors.white};
    width: fit-content;
    min-width: 400px;
    padding: 25px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 12px;
    box-shadow: 0 12px 32px 0 rgba(52, 52, 52, 0.16);
    position: relative;
    top: 20px;

    & > span {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }

    & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        font-size: 14px;
        color: #59606a;

        & > *:first-child {
            flex: 1 0 auto;
        }

        & > *:last-child {
            background: #f2f2ff;
            font-weight: 500;
            color: #1a1a1a;
            padding: 6px 10px;
        }
    }
`;

export const Control = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;

    & > div {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    & > h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
    }
`;

export const FilterContainer = styled.div`
    width: 330px;
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 13px rgba(0, 0, 0, 0.1);
    position: absolute;
    padding: 12px 20px 20px 20px;
    box-sizing: border-box;
    top: 45px;
    left: 0;
    z-index: 1;
    transition: all 1s linear;
    &.visible {
        visibility: visible;
        display: block;
        opacity: 1;
        transition: opacity 0.15s linear;
    }
    &.hidden {
        visibility: hidden;
        display: none;
        opacity: 0;
        transition: visibility 0s 0.15s, opacity 0.15s linear;
    }
`;

export const FilterTitle = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
`;

export const FilterControl = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-top: 10px;

    & > * {
        width: 100%;
    }
`;
